module.exports = __webpack_public_path__ + "img/available-downloads-fill.cd69277b.svg";